import React from 'react';
import { useTranslation } from 'react-i18next';

import { Autocomplete, TextField } from '@mui/material';

import { isArrayWithItems } from './../../../../../utils/common';

import { useUsersTableContext } from '../../store/usersTableProvider';

const getUsersTableLastNameOptions = users => {
    if (!isArrayWithItems(users)) {
        return [];
    }

    return users
        .map(user => {
            return {
                title: user.lastName,
                value: user.lastName,
            };
        })
        .sort((a, b) => a?.value?.localeCompare(b?.value));
};

const UsersTableLastNameFilter = ({ users, value = null }) => {
    const { t } = useTranslation();
    const { setUsersTableFilter } = useUsersTableContext();

    const options = getUsersTableLastNameOptions(users);

    const inputValue = value ? options.find(option => option.value === value) : null;

    return (
        <Autocomplete
            value={inputValue}
            fullWidth
            isOptionEqualToValue={(option, optionValue) => option.value === optionValue?.value}
            options={options}
            getOptionLabel={option => option.title}
            renderInput={params => <TextField {...params} label={t('adminPage.usersTable.lastName')} />}
            onChange={(_, data) => {
                setUsersTableFilter({ key: 'lastNameFilter', value: data?.value });
            }}
        />
    );
};

export default UsersTableLastNameFilter;
